<template>
  <div class="oneui">
    <div></div>
    <div
      class="center-div"
      style="display: grid; position: fixed; width: 100vw; height: var(--top-padding)"
    >
      <div class="nameWrapper" style="grid-template-columns: 1fr">
        <div></div>
        <div
          :class="currentView == 'scan' ? '' : 'current'"
          @click="currentView = 'manual'"
        >
          <span>{{ $t("components.modal.manualAdd") }}</span>
        </div>
        <div></div>
      </div>
    </div>
    <div class="pageWrapper">
      <div v-if="currentView == 'manual'" class="page center-div">
        <div v-if="!addingChild" class="form">
          <input
            type="file"
            @change="setImage"
            style="display: none"
            accept=".jpg, .jpeg, .png"
          />
          <center>
            <label for="name">{{ $t("pages.parents.addChild.name") }}</label>
            <input
              required
              v-model="name"
              autocomplete="off"
              id="name"
              :placeholder="$t('pages.parents.addChild.name')"
            />
            <br />
            <label for="age">{{ $t("pages.parents.addChild.age") }}</label>
            <input
              required
              id="age"
              autocomplete="off"
              type="number"
              min="3"
              :placeholder="$t('pages.parents.addChild.age')"
              max="17"
              pattern="[0-9]*"
              v-model="age"
            />
            <div class="btn bnt-wide btn-solid" @click="addChild()">
              <span v-if="!addingChild">{{ $t("pages.parents.addChild.button") }}</span>
              <span v-else>{{ $t("general.loading") }}</span>
            </div>

            <br />
            <div
              v-if="$root.$data.kids.length !== 0"
              class="btn bnt-wide btn-solid"
              @click="cancel()"
            >
              {{ $t("generic.cancel") }}
            </div>
          </center>
        </div>
        <div v-else id="circle1"></div>
        <!-- <div style="padding-top: 100px">May take a while if adding an image</div> -->
      </div>
      <div v-show="currentView == 'scan'" class="page center-div">
        <div v-if="!addingChild" class="form">
          <center>
            <div id="scanbox"></div>
            <input
              maxlength="10"
              minlength="10"
              v-model="linkingCode"
              @keydown="checkCode()"
              @change="checkCode()"
              placeholder="Enter Linking Code"
            />
            <span id="scanMessage"
              >Make sure to hold device still for around 3 seconds.</span
            >
            <div id="scanWrapper">
              <div class="btn bnt-wide btn-solid" @click="checkCode()">
                <strong>{{ $t("pages.parents.addChild.button") }}</strong>
              </div>
              <br />
              <div
                v-if="$root.$data.kids.length !== 0"
                class="btn bnt-wide btn-solid"
                @click="cancel()"
              >
                {{ $t("generic.cancel") }}
              </div>
            </div>
          </center>
        </div>
        <div v-else id="circle1"></div>
        <!-- <div style="padding-top: 100px">May take a while if adding an image</div> -->
      </div>
    </div>
  </div>
</template>

<script>
/* NPM IMPORTS */
import * as Parse from "parse";
import * as ModernModals from "modern-modals";
/* JS IMPORTS */
import * as CCParse from "../../utilities/parse.js";
const child =
  "data:image/png;base64,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";
const defaultImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAABmJLR0QA/wD/AP+gvaeTAAABg0lEQVRoge2aQU7DMBBFH5Qt4gLNuleBc8KiQKWwqsSCywBLQGp6gLJIK4XUSRx74pjRPClSFu78ebJbpaOAYRiG8f8pgA1QAYfMrgoogZWk7HcGYkPXz7HXaDYZyPheT0MyFx7CFXDtsS4HKuCmb4GP8EGml2T0Ol2m6iIXTFg7JqydOYRfqB8QiuN9dkg/GFw1ai+Ae+GMbITbslNJZyHcJTuF9OzCQ7InpKSjSSF7QkI6mtDgNeeyLnnXmnVEbjRSO7sAHhz1nzvWhu50NGMDS4dAc9dc9btOQxmQH83YwKWj8eYR7arvkl4G5EcTI+z6PvbVb0sXAfnRjA3cUksXuI/kUP2y8fmttPAcE4925tT1/2D/lrRjwtoxYe2YsHZMWDsmrB0T1o4JO9hP3oUcu6EFPsJvAo2k4lWiyIr6laCxoxbfEYxU3S/OB4jBFNSz5l2Gwjvg0VfWZ6YlTVs6aQ/2K60dE9aOCWvHhBPw2bj/mCE/OXfUou/A7cy9GOr4BRt7O6YsKhX6AAAAAElFTkSuQmCC";
export default {
  name: "AddChild",
  data() {
    return {
      name: "",
      age: null,
      image: defaultImage,
      imageChanged: false,
      addingChild: false,
      currentView: "manual",
      linkingCode: null,
    };
  },
  async mounted() {
    const data = this.$data;
    const user = Parse.User.current();
    this.$root.initLoadChores();
    if (user) {
      CCParse.getParent();
      this.$root.$data.showNavbar = false;
      if (navigator.userAgent.includes("iOSApp")) {
        $_("scanbox").style.display = "none";
        $_("scanMessage").style.display = "none";
      } else {
        window.onQRCodeScanned = function (scannedText) {
          CCParse.addChildViaLinkCode(scannedText).then(() => {
            CCParse.confirmLinking(scannedText);
            scanner.stopScanning();
            scanner.destroy();
          });
        };
      }
    }
  },
  methods: {
    async addChild() {
      let _t = this;
      let newKid = _t.$data;
      if (_t.$root.$data.kids.length >= 5) {
        let alertRet = await ModernModals.alert(
          _t.$t("pages.parents.addChild.error.tooManyKids.title"),
          _t.$t("pages.parents.addChild.error.tooManyKids.subtitle")
        );
        return;
      } else if (newKid.name.trim().length < 1) {
        await ModernModals.alert(
          _t.$t("pages.parents.addChild.error.nameTooShort.title"),
          _t.$t("pages.parents.addChild.error.nameTooShort.subtitle")
        );
        return;
      } else if (newKid.name.length > 21) {
        await ModernModals.alert(
          _t.$t("pages.parents.addChild.error.nameTooLong.title"),
          _t.$t("pages.parents.addChild.error.nameTooLong.subtitle")
        );
        return;
      } else if (0 >= newKid.age) {
        await ModernModals.alert(
          _t.$t("pages.parents.addChild.error.notOldEnough.title"),
          _t.$t("pages.parents.addChild.error.notOldEnough.subtitle")
        );
        return;
      } else if (newKid.age > 17) {
        await ModernModals.alert("Too old!", "Please choose an age under 18.");
        return;
      } else {
        $(".btn").addClass("disabled");
        if (_t.$data.image == defaultImage) _t.$data.image = child;
        this.$data.addingChild = true;
        CCParse.addChild(_t)
          .then(async () => {
            ModernModals.alert(
              "If your child has their own device have them download the Chore Champion app and login to the family account."
            ).then(() => {
              window.location.href = "/#/";
              window.location.reload(true);
            });
          })
          .catch((e) => {
            this.$data.addingChild = true;
            $(".btn").removeClass("disabled");
            ModernModals.alert("Error adding child!");
          });
      }
    },
    async setImage(e) {
      const file = e.target.files[0];
      if (file) {
        try {
          var imageCompression = require("browser-image-compression");
          var fixOrientation = require("fix-orientation");

          this.$data.image =
            "https://upload.wikimedia.org/wikipedia/commons/a/a3/Lightness_rotate_36f_cw.gif";
          const options = {
            maxSizeMB: 0.5,
          };
          let C_file = await imageCompression(file, options);
          const fr = new FileReader();
          fr.onload = () => {
            fixOrientation(fr.result, { image: true }, (fixed, image) => {
              this.$data.image = fixed;
            });
          };
          this.$data.imageChanged = true;
          fr.readAsDataURL(C_file);
        } catch {
          const fr = new FileReader();

          fr.onload = () => {
            this.$data.image = fr.result;
          };
          this.$data.imageChanged = true;
          fr.readAsDataURL(C_file);
        }
      }
    },
    cancel() {
      this.$root.$data.showNavbar = true;
      this.$router.replace("/");
    },
    checkCode() {
      CCParse.addChildViaLinkCode(this.$data.linkingCode).then(() => {
        // if (Pasrse.)
        CCParse.confirmLinking(this.$data.linkingCode);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  height: calc(100vh - var(--top-padding));
  min-height: unset !important;
  padding: 40px 10px;
}
.oneui {
  height: 100vh;
  overflow: hidden;
}
.avatar-wrapper {
  background-color: var(--layout-bg);

  --form-avatar-font-size: calc(var(--form-avatar-size) / 2);
  position: relative;
  height: var(--form-avatar-size);
  width: var(--form-avatar-size);
  margin: calc(var(--form-avatar-size) / 4) auto;
  border-radius: 50%;
  background-repeat: no-repeat;
  overflow: hidden;
  background-position: center;
  box-shadow: 0.0625rem 0.0625rem 0.9375rem -0.3125rem black;
  transition: all 0.3s ease;
  background-size: 50%;
  &-changed {
    background-size: cover;
  }
}

.form {
  width: 100%;
}
#scanbox {
  max-height: 50vh;
  overflow: hidden;
}
#scanWrapper {
  margin: 11px 0;
}
#scanMessage {
  color: white;
}
</style>
